import { faMagnifyingGlass, faPaperclip, faPlus, faXmark, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import ImageUpload from '../../../Components/common/ImageUpload.js';
import { Link } from 'react-router-dom';
import ActivityComments from '../../../Components/common/ActivityComments.js';
import { Badge, Button, Tab, Tabs, Modal, Row, Col } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import trash from "../../../assets/images/trash.png";
import Export from "../../../assets/images/export.svg";
import edit from "../../../assets/images/edit.png";
import Docmnt from '../../../assets/images/google-docs.png';
import Cargoplane from "../../../assets/images/plane.svg";
import Finalize from "../../../assets/images/finalize.png";
import { withRFSToken } from '../../../Services/axios.js';
import { GETULDDETAILS, MVTHDETAILS } from '../../../Utils/conts.js';
import Rapdf from "../../../assets/images/pdf.png"
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import CommonGrid from '../../../Components/common/CommonGrid.js';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const BuildUp = () => {

    const tabName = localStorage.getItem('grid_tab');
    const [activeTab, setActiveTab] = useState(tabName || 'Active');
    const [detailsId, setDetailsId] = useState();

    const [isLoading, setIsLoading] = useState(true);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [modal, setModal] = useState(false);
    const [formData, setFormData] = useState({
        picked_by: '', checked_by: '', type: '', contours_checked: '', nets_placed: '', straps_used: '', image: '',
    })
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
        // Trash: []

    });
    const isMounted = useRef(false);

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const [filterApplied, setFilterApplied] = useState(false);
    const [totalRows, setTotalRows] = useState({});
    const [totalRowsR, setTotalRowsR] = useState(0);
    const [gridSelect, setGridSelect] = useState([]);
    const [editData, setEditData] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        localStorage.setItem('grid_tab', tab);
        //const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }

    };

    let checkUlds = [];
    let filterForCheck = false;

    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData({ Active: {} });
        localStorage.removeItem("source_page");

        isMounted.current = true;
    }, []);

    let columns = [
        {
            text: 'Actions',
            cellsrenderer: function () {
                return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_trash" /></div>';
            },
            width: '5%', filterable: false,
        },
        { text: 'Created', filtertype: 'textbox', datafield: 'created', width: '8%', cellclassname: '', },
        { text: 'ULD Number', filtertype: 'input', datafield: 'uld_number', width: '8%', cellclassname: '', },
        {
            text: 'Build Up Status',
            cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                if (rowdata.buildup_status === 'In Progress') {
                    return '<div class="jqx-grid-cell-left-align fw_progess">In Progress</div>';
                } else if (rowdata.buildup_status === 'Finalized') {
                    return '<div class="jqx-grid-cell-left-align fw_complet">Finalized</div>';
                } else {
                    return defaulthtml;
                }

            },
            datafield: 'buildup_status', width: '8%',
            filterable: true, filtertype: 'checkedlist',
            filteritems: [
                { label: 'In Progress', value: 'In Progress' },
                { label: 'Finalized', value: 'Finalized' },
            ],
        },
        {
            text: 'Build Up Receipt', datafield: 'view_docs', width: '5%',

            cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                    defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                }
                return (
                    defaultHtml
                );
            },
        },
        { text: 'Department Name', filtertype: 'textbox', datafield: 'department_name', width: '8%', cellclassname: '', },
        { text: 'Type Code', filtertype: 'input', datafield: 'type_code', width: '6%', cellclassname: '', },
        { text: 'Serial Number', filtertype: 'input', datafield: 'serial_number', width: '8%', cellclassname: '', },
        { text: 'Owner Code', filtertype: 'input', datafield: 'owner_code', width: '8%', cellclassname: '', },
        { text: 'Condition Code', filtertype: 'textbox', datafield: 'condition_code', width: '8%', cellclassname: '', },
        { text: 'Airline', filtertype: 'textbox', datafield: 'airline', width: '8%', cellclassname: '', },
        { text: 'Origin Company', filtertype: 'textbox', datafield: 'origin', width: '8%', cellclassname: '', },
        { text: 'Airway Bill', filtertype: 'input', datafield: 'airway_bill', width: '8%', cellclassname: '', },

    ];
    if (activeTab === 'Archived') {
        columns = columns.filter(col => col.datafield !== 'buildup_status');
    }
    const datafields = [
        { name: 'id', type: 'string' },
        { name: 'uld_id', type: 'string' },
        { name: 'buildup_Id', type: 'string' },
        { name: 'created', type: 'string' },
        { name: 'uld_number', type: 'string' },
        { name: 'buildup_status', type: 'string' },
        { name: 'build_up_receipt', type: 'string' },
        { name: 'department_name', type: 'string' },
        { name: 'type_code', type: 'string' },
        { name: 'serial_number', type: 'string' },
        { name: 'owner_code', type: 'string' },
        { name: 'condition_code', type: 'string' },
        { name: 'airline', type: 'string' },
        { name: 'origin', type: 'string' },
        { name: 'airway_bill', type: 'string' },
        { name: 'view_docs', type: 'string' },

    ];
    const nestedColumns = [
        {
            text: 'Actions',
            cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
                if (cellValue.airway_bill) {
                    return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                }
            },
            width: '5%', filterable: false,
        },
        { text: 'Airway Bill', filtertype: 'textbox', datafield: 'airway_bill', width: '8%', cellclassname: '', },
        { text: 'Pcs', filtertype: 'textbox', datafield: 'pcs', width: '8%', cellclassname: '', },
        { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '8%', cellclassname: '', },
        { text: 'Custom Code', filtertype: 'textbox', datafield: 'custom_code', width: '8%', cellclassname: '', },
        { text: 'Special Handling Code', filtertype: 'textbox', datafield: 'special_handling_code', width: '12  %', cellclassname: '', },
        { text: 'Security Code', filtertype: 'textbox', datafield: 'security_code', width: '8%', cellclassname: '', },
        { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '8%', cellclassname: '', },
        { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '8%', cellclassname: '', },
    ];


    const gridData1 = {
        Tabs: ['Active', 'Archived'],
        TabMap: {
            'Active': 'A',
            'Archived': 'I'
        },
        ActiveTab: 'Active',
        Token: `ULD`,
        page: 'org',
        EndPoint: 'uld-control/build-up?tab_type=',
        Datafields: datafields,
        cellClickIndex: 2,
        Columns: columns,
        selectionID: 'uld_id',
        nested: true,
        nestedURL: 'uld-control/sub-build-up?uld_id=',
        nestedColumns: nestedColumns,
        nestedkey: 'uld_id',
        Options: {
            height: 1040,
            pageSize: 50,
            pagesizeoptions: ['50', '100', '200', '500'],
            selectionmode: 'checkbox',
        },
    }

    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_id', type: 'string' },
                    { name: 'buildup_Id', type: 'string' },
                    { name: 'created', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'buildup_status', type: 'string' },
                    { name: 'build_up_receipt', type: 'string' },
                    { name: 'department_name', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'airline', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'view_docs', type: 'string' },

                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}uld-control/build-up?tab_type=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    setTotalRows({ totalUlds: data.activeCount });
                    setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            let columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_trash" /></div>';
                    },
                    width: '5%', filterable: false,
                },
                { text: 'Created', filtertype: 'textbox', datafield: 'created', width: '8%', cellclassname: '', },
                { text: 'ULD Number', filtertype: 'input', datafield: 'uld_number', width: '8%', cellclassname: '', },
                {
                    text: 'Build Up Status',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.buildup_status === 'In Progress') {
                            return '<div class="jqx-grid-cell-left-align fw_progess">In Progress</div>';
                        } else if (rowdata.buildup_status === 'Finalized') {
                            return '<div class="jqx-grid-cell-left-align fw_complet">Finalized</div>';
                        } else {
                            return defaulthtml;
                        }

                    },
                    datafield: 'buildup_status', width: '8%',
                    filterable: true, filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'In Progress', value: 'In Progress' },
                        { label: 'Finalized', value: 'Finalized' },
                    ],
                },
                {
                    text: 'Build Up Receipt', datafield: 'view_docs', width: '5%',

                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                { text: 'Department Name', filtertype: 'textbox', datafield: 'department_name', width: '8%', cellclassname: '', },
                { text: 'Type Code', filtertype: 'input', datafield: 'type_code', width: '6%', cellclassname: '', },
                { text: 'Serial Number', filtertype: 'input', datafield: 'serial_number', width: '8%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'input', datafield: 'owner_code', width: '8%', cellclassname: '', },
                { text: 'Condition Code', filtertype: 'textbox', datafield: 'condition_code', width: '8%', cellclassname: '', },
                { text: 'Airline', filtertype: 'textbox', datafield: 'airline', width: '8%', cellclassname: '', },
                { text: 'Origin Company', filtertype: 'textbox', datafield: 'origin', width: '8%', cellclassname: '', },
                { text: 'Airway Bill', filtertype: 'input', datafield: 'airway_bill', width: '8%', cellclassname: '', },

            ];
            if (activeTab === 'Archived') {
                columns = columns.filter(col => col.datafield !== 'buildup_status');
            }
            // Nested Start
            const nestedColumns = [
                {
                    text: 'Actions',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
                        if (cellValue.airway_bill) {
                            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                        }
                    },
                    width: '5%', filterable: false,
                },
                { text: 'Airway Bill', filtertype: 'textbox', datafield: 'airway_bill', width: '8%', cellclassname: '', },
                { text: 'Pcs', filtertype: 'textbox', datafield: 'pcs', width: '8%', cellclassname: '', },
                { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '8%', cellclassname: '', },
                { text: 'Custom Code', filtertype: 'textbox', datafield: 'custom_code', width: '8%', cellclassname: '', },
                { text: 'Special Handling Code', filtertype: 'textbox', datafield: 'special_handling_code', width: '12  %', cellclassname: '', },
                { text: 'Security Code', filtertype: 'textbox', datafield: 'security_code', width: '8%', cellclassname: '', },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '8%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '8%', cellclassname: '', },
            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

                const parentRowId = record.uld_id.toString();
                nestedGrids[parentRowId] = nestedGridContainer;

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // console.log('Nested arrow clicked:', record);
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });
                console.log(dataAdapter);
                const id = record.uld_id.toString();
                console.log('ov >>:', dataAdapter.loadedData.Rows[id]);
                // const uldGrid = dataAdapter.loadedData.Rows[id].cargoid;
                // const hawbGrid = dataAdapter.loadedData.Rows[id].hawb_id;             
                let subendPoint = `uld-control/sub-build-up?uld_id=${id}`
                const nestedSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'airway_bill', type: 'string' },
                        { name: 'pcs', type: 'string' },
                        { name: 'weight', type: 'string' },
                        { name: 'custom_code', type: 'string' },
                        { name: 'special_handling_code', type: 'string' },
                        { name: 'security_code', type: 'string' },
                        { name: 'origin', type: 'string' },
                        { name: 'destination', type: 'string' },
                    ],
                    url: `${process.env.REACT_APP_RFS_URL}${subendPoint}`,
                    // beforeSend: function (jqXHR) {
                    //     jqXHR.setRequestHeader('Authorization', token);
                    // },
                    pagesize: 50,
                    filter: function (allfilters) {
                        if (allfilters.length > 0) {
                            setFilterApplied(true);
                            filterForCheck = true;
                        } else {
                            setFilterApplied(false);
                            filterForCheck = false;
                        }
                        window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                        // setTimeout(() => {
                        //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                        //     console.log("rows", rows);
                        //     (checkUlds).forEach(uldNumber => {
                        //         console.log(checkUlds);
                        //         rows.forEach((element, index) => {
                        //             if (element.uld_number == uldNumber) {
                        //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                        //             }
                        //         });
                        //     });
                        // }, 4000);
                    },
                    beforeprocessing: function (data) {
                        source.totalrecords = data.TotalRows;
                        setTotalRows({ totalUlds: data.activeCount });
                        setTotalRowsR({ totalUlds: data.archiveCount });
                    },
                    sort: function () {
                        window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                    },
                    root: "Rows",
                    cache: false,
                }

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                // SUB SUB NESTED START
                const subsubColumns = [
                    { text: 'House Awb', datafield: 'house_awb', width: '8%' },
                    { text: 'Pcs', datafield: 'pieces', width: '8%' },
                    { text: 'Weight', datafield: 'weight', width: '8%' },
                ];
                const awbGrids = {};
                const hawbrowdetails = (index, parentElement, gridElement, record) => {
                    const awbGridContainer = parentElement.children[0];
                    const parentRowId = record.id ? record.id.toString() : null;
                    awbGrids[parentRowId] = awbGridContainer;

                    parentElement.addEventListener('click', (event) => {
                        const target = event.target;
                        // Check if the click target is the awb arrow
                        if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                            // Handle awb arrow click here
                            // console.log('Nested arrow clicked:', record);
                            event.stopPropagation(); // Prevent event bubbling to the row details
                        }
                    });
                    // console.log('jjjjjjjjjjjjj:', record.id);
                    const id = record.id ? record.id.toString() : null;

                    let subsubendPoint = `uld-control/sub-sub-build-up?id=${id}`
                    const subsubSource = {
                        datatype: 'json',
                        id: 'shipmentChildID',
                        datafields: [
                            { name: 'id', type: 'string' },
                            { name: 'house_awb', type: 'string' },
                            { name: 'pieces', type: 'string' },
                            { name: 'weight', type: 'string' },

                        ],
                        url: `${process.env.REACT_APP_RFS_URL}${subsubendPoint}`,
                        // beforeSend: function (jqXHR) {
                        //     jqXHR.setRequestHeader('Authorization', token);
                        // },
                        pagesize: 50,
                        filter: function (allfilters) {
                            if (allfilters.length > 0) {
                                setFilterApplied(true);
                                filterForCheck = true;
                            } else {
                                setFilterApplied(false);
                                filterForCheck = false;
                            }
                            window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                            // setTimeout(() => {
                            //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                            //     console.log("rows", rows);
                            //     (checkUlds).forEach(uldNumber => {
                            //         console.log(checkUlds);
                            //         rows.forEach((element, index) => {
                            //             if (element.uld_number == uldNumber) {
                            //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            //             }
                            //         });
                            //     });
                            // }, 4000);
                        },
                        beforeprocessing: function (data) {
                            source.totalrecords = data.TotalRows;
                            setTotalRows({ totalUlds: data.activeCount });
                            setTotalRowsR({ totalUlds: data.archiveCount });
                        },
                        sort: function () {
                            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                        },
                        root: "Rows",
                        cache: false,
                    }

                    const subsubDataAdapter = new window.$.jqx.dataAdapter(subsubSource);

                    const awbGridOptions = {
                        width: '100%',
                        pageable: false,
                        sortable: false,
                        // pageSize: 15,
                        autoheight: false,
                        height: (6 * 45),
                        selectionmode: '',
                        source: subsubDataAdapter,
                        filterable: false,
                        columns: subsubColumns,
                        rowdetails: true,
                        rowsheight: 45,
                        showemptyrow: false,
                        ready: function () {
                            // Manually set row IDs starting from 0
                            const rows = window.$(awbGridContainer).jqxGrid('getrows');
                            for (let i = 0; i < rows.length; i++) {
                                const rowid = i; // Use index as the new row ID
                                const row = rows[i];
                                window.$(awbGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                                window.$(awbGridContainer).jqxGrid('updaterow', rowid, row);
                                window.$(awbGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                            }
                        },
                    };
                    window.$(awbGridContainer).jqxGrid(awbGridOptions);

                };
                // SUB SUB NESTED END

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: (10 * 45),
                    selectionmode: '', // checkbox
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    initrowdetails: hawbrowdetails,

                    rowdetailstemplate: {
                        rowdetails: '<div id="hawbGrid" style="margin: 10px;"></div>',
                        rowdetailsheight: (6 * 45),
                        rowdetailshidden: true,
                    },
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };
            // Nested End

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                initrowdetails: initrowdetails,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (10 * 45),
                    rowdetailshidden: true,
                },
                // rendered: function () {
                //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                //     (checkUlds).forEach(uldNumber => {
                //         rows.forEach((element, index) => {
                //             if (element.uld_number == uldNumber) {
                //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                //             }
                //         });
                //     });
                // }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                const pageIndex = pagingInfo.pagenum;
                const pageSize = pagingInfo.pagesize;
                const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);

                localStorage.setItem('uld_id', JSON.stringify(rowData.uld_id));
                localStorage.setItem('grid_tab', activeTab);
                window.location.replace('ActionBuildUp');
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_trash', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                const pageIndex = pagingInfo.pagenum;
                const pageSize = pagingInfo.pagesize;
                const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);

                setShowConfirmation(true);
                setDeleteId(rowData.uld_id);
            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }

                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                console.log("🚀 ~ window.$ ~ args:", args)
                if (event.args.columnindex > 2) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    // loadDetails(args.uld_id);
                    setDetailsId(args.uld_id);
                }
            });
        }

    }, [gridData]);
    const loadDetails = async (uldNumber) => {
        // setDisLoading(true);
        try {
            const res = await withRFSToken.post('uld-control/build-up-details', { uld_id: String(uldNumber) });
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                setSelectedRowData(innerData);
                // setDisLoading(false);
                // setTimeout(() => {
                //     window.$(gridRefs[activeTab].current).jqxGrid('refresh');
                // }, 30);
            } else {
                toast.error(res.data.response_msg);
                // setDisLoading(false);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
        // setTimeout(() => {
        //     window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        // }, 30);
    };

    const handleModalClose = () => {
        setShowConfirmation(false);
    };

    const handleConfirmation = async () => {
        try {
            const res = await withRFSToken.post('forwarder-action/delete-build-up', { uld_id: deleteId })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setTimeout(() => {
                        setIsLoading(false);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
                    }, 1);
                    setShowConfirmation(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    };

    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);


    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        const existingBase64Files = formData?.base64Files || [];
        let filesProcessed = 0;

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // filesWithBase64.push({ file, base64: reader.result });
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesWithBase64.length === selectedFiles.length) {
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    setFormData((prevFiles) => ({ ...prevFiles, attachments: mergedBase64Files }));
                }
            };
            reader.readAsDataURL(file);
        });
    }
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    const handleDetailsClick = async (history) => {

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }

        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }



    };

    const [actArcModal, setActArcModal] = useState(false);
    const [confPos, setConfPos] = useState('');
    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            setActArcModal(true);
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
        }
    };
    const confirmMoveToActArc = async () => {
        // console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? 'I' : 'A';
        const uldNumbers = gridSelect && gridSelect.map(num => num.uld_id)
        try {
            const res = await withRFSToken.post('forwarder-action/archive-build-up', { buildup_Id: uldNumbers, activity_status: sendAction })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        toast.success(res.data.response_msg);
                        // setGridSelect([]);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        // fetchDataGrid()
                        // if (activeTab == 'Active') {
                        //     toast.success('ULD Data moved to Arhive');
                        //     fetchDataGrid()
                        // } else {
                        //     toast.success('ULD Data moved to Active');
                        //     fetchDataGridR()
                        // }
                        setActArcModal(false)
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleFinalize = () => {
        if (gridSelect.length === 0) {
            toast.error("No ULD selected")
            return;
        }
        if (gridSelect.length > 1) {
            toast.error("Only one ULD can be finalized at a time");
            gridSelect.forEach(selectedItem => {
                const selectedRowBoundIndex = selectedItem.boundindex;
                if (selectedRowBoundIndex !== undefined && selectedRowBoundIndex !== null) {
                    window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                }
            });
            return;
        }
        // add modal 
        if (gridSelect[0].buildup_status === 'Finalized') {
            setConfPos('F')
            setActArcModal(true)
        } else {
            setModal(true);
        }
    }

    const confFinalizeModal = () => {
        setActArcModal(false);
        setModal(true);
    }

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmitFinalize = async () => {
        console.log('formData', formData);
        const trandformData = { ...formData, buildup_Id: gridSelect[0].buildup_Id }
        try {
            const res = await withRFSToken.post('forwarder-action/finalize-build-up', trandformData)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    // setSelectedRowData(innerData);
                    setModal(false);
                    setTimeout(() => {
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
                    }, 1);
                    gridSelect.forEach(selectedItem => {
                        const selectedRowBoundIndex = selectedItem.boundindex;
                        if (selectedRowBoundIndex !== undefined && selectedRowBoundIndex !== null) {
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        }
                    });

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleDetails = () => {

        const localData = { id: selectedRowData.id, backUrl: '/ULDForwarder/BuildUp' }
        localStorage.setItem('Fdetails', JSON.stringify(localData));
        localStorage.setItem('source_page', 'buildup');
        window.location.href = '/ULDForwarder/Details';
    }

    const selectedRow = (dd) => {
        console.log('dd', dd);

    }
    const handleSwitch = async (apiData) => {
        console.log('id', apiData);
        let endPoint = '';
        let payload = {};
        if (apiData.section == 'cellclick') {
            setSelectedRowData(apiData.data)
        } else if (apiData.section == 'row_edit') {
            localStorage.setItem('uld_id', JSON.stringify(apiData.uld_id));
            localStorage.setItem('grid_tab', activeTab);
        }
    }

    return (
        <>
            {console.log('formData', formData)}
            {console.log('files', gridSelect)}
            {/* <div className="">
                <Header />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='FORWARDER' />
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-end mb-3 order_search'>
                                        <div className='search'>
                                            <div className="form-group has-search"> */}
            {/* <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                                <input type="text" className="form-control" placeholder="Search" /> */}
            {/* </div>

                                        </div>
                                    </div>
                                    <div className="lcontent"> */}
            <div className="mb-0 nestedtabs rounded">
                <div className='d-flex justify-content-between'>
                    <div className='d-flex'>
                        <div className='me-3'>
                            <button className="finalize_btn" variant="primary" onClick={handleFinalize}>
                                <span className='flex_center'> <img src={Finalize} />  Finalize</span>
                            </button>
                        </div>

                        <span className="selected">
                            Selected ULD <Badge>{gridSelect.length}</Badge>
                        </span>
                    </div>
                    <div className='d-flex'>
                        <div className='ulddown'>
                            {activeTab === 'Active' && <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button>}
                            {activeTab === 'Archived' && <button onClick={handleMoveToActArc}> <img title='' src={Activ} /> Active </button>}
                            <button ><img src={Export} /> Download</button>
                        </div>
                    </div>

                </div>

            </div>
            <div className='maindiv'>
                <div className='trashdonload'>
                    <CommonGrid GD={gridData1} onAction={handleSwitch} activeTab={activeTab} setActiveTab={setActiveTab} setGridSelect={setGridSelect} gridSelect={gridSelect} />
                    {/* <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'> */}
                    {/* <Loader isLoading={isLoading} /> */}
                    {/* {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            } */}
                    {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                    {/* </Tab>
                        <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'> */}
                    {/* <Loader isLoading={isLoading} /> */}
                    {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>} */}
                    {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                    {/* </Tab>
                    </Tabs> */}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_det_id} &nbsp;
                                <span
                                    className={
                                        selectedRowData.buildup_status == 'Finalized' ? 'fw_complet'
                                            : selectedRowData.buildup_status == 'In Progress' ? 'fw_progess'
                                                : ''}>
                                    {selectedRowData.buildup_status}
                                </span>
                            </h3>
                            <div className='d-flex actbtn justify-content-between'>
                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                <div className='viwall'>
                                    <Link to='#' onClick={handleDetails}>View Details</Link>
                                </div>
                            </div>

                        </div>

                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"forwarder_build_up"}
                            attachable_id={selectedRowData.id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.uld_id)}
                        />
                        <ActivityComments
                            commentable_type={"forwarder_build_up"}
                            commentable_id={selectedRowData.id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails(selectedRowData.uld_id)}
                        />
                    </div>
                )}
            </div>
            {/* </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {confPos === 'F' ?
                        <>
                            <h3>ULD already finalized.</h3>
                            <p>Would you like to proceed?</p>
                        </>
                        :
                        <>
                            <h3>Selected {gridSelect.length > 1 ? "Row's" : 'Row'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
                            <p>Are you sure you want to move {gridSelect.length > 1 ? "Row's" : 'Row'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setActArcModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={confPos === 'F' ? confFinalizeModal : confirmMoveToActArc}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={modal} onHide={() => setModal(false)} className='addfrom' centered >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm={6}>
                            <Form.Label>Picked By <span>*</span></Form.Label>
                            <Form.Control type="text" onChange={handleAddressChange} name='picked_by' placeholder="Picked By" />
                        </Col>
                        <Col sm={6}>
                            <Form.Label>Checked By <span>*</span></Form.Label>
                            <Form.Control type="text" onChange={handleAddressChange} name='checked_by' placeholder="Checked By" />
                        </Col>
                    </Form.Group>
                    {/* <Form.Group className='mb-2'>
                            <Form.Label>Checked By</Form.Label>
                            <Form.Control type="text" onChange={handleAddressChange} name='checked_by' placeholder="Checked By" />
                        </Form.Group> */}
                    <Row>
                        <Col sm='12'>
                            <Form.Group className='mb-2'>
                                <Form.Label>Type <span>*</span></Form.Label>
                                <Form.Check
                                    inline
                                    label="Main Deck"
                                    name="type"
                                    id='my'
                                    type='radio'
                                    value='Y'
                                    checked={formData.type == 'Y'}
                                    onChange={handleAddressChange}
                                />

                                <Form.Check
                                    inline
                                    label="Lower Deck"
                                    value="N"
                                    id='ly'
                                    name="type"
                                    type='radio'
                                    // id='import'
                                    checked={formData.type == 'N'}
                                    onChange={handleAddressChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col sm='6'>
                            <Form.Group className='mb-2'>
                                <Form.Label>Contours Checked <span>*</span></Form.Label>
                                <Form.Check
                                    inline
                                    label="Yes"
                                    name="contours_checked"
                                    id='contoursy'
                                    type='radio'
                                    value='1'
                                    checked={formData.contours_checked === '1'}
                                    onChange={handleAddressChange}
                                />

                                <Form.Check
                                    inline
                                    label="No"
                                    name="contours_checked"
                                    id='contoursn'
                                    type='radio'
                                    value='0'
                                    checked={formData.contours_checked === '0'}
                                    onChange={handleAddressChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col sm='6'>
                            <Form.Group className='mb-2'>
                                <Form.Label>Nets Placed <span>*</span></Form.Label>
                                <Form.Check
                                    inline
                                    label="Yes"
                                    name="nets_placed"
                                    id='netsy'
                                    type='radio'
                                    value='1'
                                    checked={formData.nets_placed === '1'}
                                    onChange={handleAddressChange}
                                />

                                <Form.Check
                                    inline
                                    label="No"
                                    name="nets_placed"
                                    id='netsn'
                                    type='radio'
                                    value='0'
                                    checked={formData.nets_placed === '0'}
                                    onChange={handleAddressChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>

                        <Col sm='6'>
                            <Form.Group className='mb-2'>
                                <Form.Label>Straps Used <span>*</span></Form.Label>
                                <Form.Check
                                    inline
                                    label="Yes"
                                    name="straps_used"
                                    id='strapsy'
                                    type='radio'
                                    value='1'
                                    checked={formData.straps_used === '1'}
                                    onChange={handleAddressChange}
                                />
                                <Form.Check
                                    inline
                                    label="No"
                                    name="straps_used"
                                    id='strapsn'
                                    type='radio'
                                    value='0'
                                    checked={formData.straps_used === '0'}
                                    onChange={handleAddressChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div>
                        <form>
                            <h6>Upload Images/Documents</h6>
                            <div>
                                <div
                                    className='dropfile'
                                    onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                    style={{ padding: '10px 0' }}
                                >
                                    <h3>Drag and drop files here</h3>
                                    <p>Or</p>
                                    <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                    <span>Maximum file size 4 MB</span>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                        multiple
                                    />
                                </div>
                                <div className='uploadbox'>
                                    {files.map((file, index) => (
                                        <div key={index} className='uploadfil w-100'>
                                            {file.type.startsWith('image/') ? (
                                                <img
                                                    src={URL.createObjectURL(file)}
                                                    alt="Preview"
                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                />
                                            ) : (
                                                <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                            )}
                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSubmitFinalize}>
                        Finalize
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showConfirmation} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Confirm Delete</h3>
                    <p>If you proceed with the change, all data in this data will be removed.
                        Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={handleModalClose}>
                            No
                        </Button>
                        <Button variant="primary" onClick={handleConfirmation}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            {/* </div> */}
        </>
    )
}

export default BuildUp